import { render } from "./InstanceFields.vue?vue&type=template&id=3eda3078&ts=true"
import script from "./InstanceFields.vue?vue&type=script&lang=ts"
export * from "./InstanceFields.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__